import React, { useState } from "react";
import styled from "styled-components";
import Modal from "react-modal";
import PText from "../components/PText";

const TrainingPageStyles = styled.div`
  padding: 10rem 0;

  .heading {
    font-size: 3.6rem;
    margin-bottom: 1rem;
  }

  .info {
    font-size: 1.6rem;
    margin-bottom: 4rem;
  }

  .all-trainings {
    margin-top: 2rem;
    display: flex;
    gap: 2rem;
  }

  .training-card {
    flex: 1;
    background: var(--deep-dark);
    padding: 2rem;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    transition: 0.3s;

    &:hover {
      transform: translateY(-5px);
    }

    .title {
      font-size: 2rem;
      font-weight: 600;
      color: cyan;
    }

    .meta {
      font-size: 1.3rem;
      opacity: 0.8;
    }

    .btns {
      margin-top: 1rem;
      display: flex;
      gap: 1rem;

      button,
      a {
        cursor: pointer;
        background: cyan;
        border: none;
        padding: 0.5rem 1.2rem;
        border-radius: 5px;
        color: black;
        font-size: 1rem;
        text-decoration: none;
      }

      .content-btn {
        background: #ff7e08;
      }
    }
    .btns a:nth-child(1) {
      background: cyan;
    }

    .btns a:nth-child(2) {
      background: #7df9ff;
    }

    .content-btn {
      background: #ffd84d;
    }
  }
  @media only screen and (max-width: 768px) {
    .all-trainings {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    .training-card {
      width: 90%;
      margin: auto;
      .title {
        font-size: 1.5rem;
      }
      .meta {
        font-size: 1rem;
      }
      .btns {
        flex-direction: column;
        gap: 0.5rem;
        button,
        a {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
`;

const ModalStyles = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;

  .modal-content {
    width: 65%;
    height: 75%;
    background: white;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .notice {
    background: #ff7e08;
    color: black;
    padding: 1rem 2rem;
    font-size: 1.2rem;
    text-align: center;
    b {
      color: darkblue !important;
      font-weight: bold;
      text-decoration: underline;
    }
  }

  .close-btn {
    position: absolute;
    top: 8px;
    right: 12px;
    background: black;
    color: white;
    border: none;
    padding: 3px 8px;
    border-radius: 50%;
    cursor: pointer;
  }

  iframe {
    flex: 1;
    width: 100%;
    height: 100%;
  }
`;

const training_lists = [
  {
    id: 1,
    name: "Python Programming",
    hours: "30+ hours",
    year: "2024",
    syllabus:
      "https://docs.google.com/document/d/e/2PACX-1vTjUuhQwfgWJ0eD9lk7EMeDDylav4MfTJ9N3O6HQbeBwVTa60DxEEu9K70rKgfMMEpFz33uHrTok_6H/pub",
    slides:
      "https://docs.google.com/presentation/d/e/2PACX-1vT1vIGAtGINLOITNcEpOaZpla2lSexfYjcO6jp-wL6a_cKBj7ex3t_57rMmrE5PaxBe_dCT1kNRiEc-/pub?start=false&loop=false&delayms=60000",
    content: "",
  },
  {
    id: 2,
    name: "AI ML Essentials",
    hours: "30+ hours",
    year: "2025",
    syllabus:
      "https://docs.google.com/document/d/e/2PACX-1vRvw_Lk5JU23NlJffSpvbMQgZzZq070DZKbVlyTvH-6Mva7iBxnsfBY2my_qQBsWts6JsSpRr2HvAzl/pub",
    slides: "#",
    content:
      "https://docs.google.com/document/d/e/2PACX-1vRvw_Lk5JU23NlJffSpvbMQgZzZq070DZKbVlyTvH-6Mva7iBxnsfBY2my_qQBsWts6JsSpRr2HvAzl/pub",
  },
  {
    id: 3,
    name: "Generative AI & LLMs",
    hours: "40+ hours",
    year: "2025",
    syllabus:
      "https://docs.google.com/document/d/e/2PACX-1vRBo3aNBT30QWcLPQKCxARB9CF18lm-VQeVFJ0UAVSXIgSodzoAnKjqIWQ8CMmMgJhXfq51quKWSXSR/pub",
    slides: "#",
    content:
      "https://docs.google.com/document/d/e/2PACX-1vRBo3aNBT30QWcLPQKCxARB9CF18lm-VQeVFJ0UAVSXIgSodzoAnKjqIWQ8CMmMgJhXfq51quKWSXSR/pub",
  },
];

export default function TrainingSyllabus() {
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [showContentInfo, setShowContentInfo] = useState(false);

  return (
    <>
      <TrainingPageStyles>
        <div className="container">
          <h2 className="heading">Training</h2>

          <p className="info">
            Below are the outlines of professional trainings I have conducted in
            Python, AI/ML, and Generative AI.
          </p>
          <span
            style={{
              color: "gray",
              fontSize: "0.9rem",
              textDecoration: "underline",
            }}
          >
            Open in Laptop for better viewing experience
          </span>
          <div className="all-trainings">
            {training_lists.map((item) => (
              <div className="training-card" key={item.id}>
                <div className="title">{item.name}</div>

                <div className="meta">Year: {item.year}</div>
                <div className="meta">Duration: {item.hours}</div>

                <div className="btns">
                  {/* 1️⃣ Syllabus (modal open) */}
                  <button onClick={() => setSelectedDoc(item.syllabus)}>
                    Syllabus
                  </button>

                  {/* 2️⃣ Slides (redirect) */}
                  <a
                    href={item.slides}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Slides
                  </a>

                  {/* 3️⃣ Content (info modal) */}
                  <button
                    className="content-btn"
                    onClick={() => setShowContentInfo(true)}
                  >
                    Content
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </TrainingPageStyles>
      <ModalStyles
        isOpen={!!selectedDoc}
        onRequestClose={() => setSelectedDoc(null)}
      >
        <div className="modal-content">
          <button className="close-btn" onClick={() => setSelectedDoc(null)}>
            X
          </button>

          {selectedDoc && (
            <iframe
              src={selectedDoc}
              title="Training Syllabus"
              frameBorder="0"
              allowFullScreen
            />
          )}
        </div>
      </ModalStyles>
      {/* Modal */}
      <ModalStyles
        isOpen={showContentInfo}
        onRequestClose={() => setShowContentInfo(false)}
      >
        <div
          className="modal-content"
          style={{
            height: "220px",
            justifyContent: "center",
            alignItems: "center",
            padding: "2rem",
          }}
        >
          <button
            className="close-btn"
            onClick={() => setShowContentInfo(false)}
          >
            X
          </button>

          <div className="notice">
            Full training materials and project resources are not publicly
            available.
            <br />
            <br />
            Please contact:
            <b> sujansharma.ml@gmail.com</b>
            <br />
            Access may require a small training fee.
          </div>
        </div>
      </ModalStyles>
    </>
  );
}
